const ShopBoxComponent = () => import('@/views/shop/ShopBox/ShopBoxView')

export default [
    {
        path:'/ShopBoxIndex',
        name:'ShopBoxRouter',
        component:ShopBoxComponent
    }
]